module.exports = __webpack_public_path__ + "static/media/americanfootball.db463975.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/americanfootball.svg
// module id = 356
// module chunks = 7